export default __webpack_public_path__ + "static/media/division-2.3624b67d.png";